// Mapeamento manual de IDs de cargos para Nomes
// Este arquivo é necessário porque o app não tem um backend com Bot Token
// para buscar automaticamente os nomes dos cargos do Discord.
//
// INSTRUÇÕES:
// 1. Abra o Discord Developer Portal ou use o Discord em modo desenvolvedor
// 2. Copie o ID de cada cargo (botão direito > Copiar ID)
// 3. Adicione abaixo no formato: 'ID_DO_CARGO': 'Nome do Cargo'
//
// Exemplo:
// '1217325550771765291': 'Admin',
// '1004174613670023238': 'Membro VIP',

export const ROLE_MAP = {
    // ========== CAPITAL (Guild ID: 1004174613670023238) ==========
    // Adicione os cargos do servidor CAPITAL aqui:
    // 'ID': 'Nome',

    // ========== VALLEY NORTE (Guild ID: 1273010402095267840) ==========
    // Adicione os cargos do servidor VALLEY NORTE aqui:
    // 'ID': 'Nome',

    // ========== MORADA DO VALLEY (Guild ID: 1341174349469843476) ==========
    // Adicione os cargos do servidor MORADA DO VALLEY aqui:
    // 'ID': 'Nome',

    // ========== VALLEY SUL (Guild ID: 1299460857926914141) ==========
    // Adicione os cargos do servidor VALLEY SUL aqui:
    // 'ID': 'Nome',
};

// Função auxiliar para obter o nome
export const getRoleName = (roleId) => {
    return ROLE_MAP[roleId] || roleId; // Retorna o nome se existir, senão retorna o ID
};

